
import {observable} from "mobx";
import {StoreBase, StoreDataType} from "shared/utilities/Store/StoreBase";
import {PDFControlBaseOptions} from "InternalShared/PageBuilder/Controls/Core/PDFControlBase.Options";
import {PRControlTypes} from "../PRControlFactory";






export class FigureData extends StoreBase{
    Label:string;
    Value:string;
    Svg?:string;
    AllowColors:boolean;


    protected LoadDefaultValues() {
        this.Label='';
        this.Value='';
        this.Svg='';
        this.AllowColors=false;

    }
}



export class FigureControlOptions extends PDFControlBaseOptions{
    FigureData:FigureData;
    Color:string;
    Data:string;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Color='#000000';
        this.Data='';
        this.Type=PRControlTypes.Figure;
        this.FigureData=new FigureData().Merge();
        this.HideFromTemplateDesigner=true;
    }
}


